import script from "./MoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreButton.vue?vue&type=script&setup=true&lang=js"

import "./MoreButton.vue?vue&type=style&index=0&id=ca50a48a&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca50a48a"]])

export default __exports__